import React from 'react';
import { Alert, Linking, Pressable, View } from 'react-native';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { faEnvelope, faGlobe, faPhone } from '@fortawesome/pro-regular-svg-icons';
import useCustomTheme from '../../../hooks/theme-hook';
import useTranslation from '../../../hooks/translation-hook';
import { AtHomeContacts, AtHomeContactRequirements, getAtHomeContactLinks } from '../../../models/helpers/remoteMissions';
import Label, { LabelType } from '../Label';

const icons = { phone: faPhone, email: faEnvelope, website: faGlobe };

interface AtHomeContactActionsProps {
  contacts: AtHomeContacts;
  requirements: AtHomeContactRequirements;
}

const AtHomeContactActions = ({ contacts, requirements }: AtHomeContactActionsProps) => {
  const theme = useCustomTheme();
  const t = useTranslation();
  const links = getAtHomeContactLinks(contacts, requirements);
  if (!links.length) return null;

  const open = async (url: string) => {
    try {
      await Linking.openURL(url);
    } catch {
      Alert.alert(t('error'), t('Something-went-wrong-please-try-again-later'));
    }
  };

  return <View style={{ width: '100%', minWidth: 0 }}>
    {links.map(link => <Pressable key={link.kind} accessibilityRole="link"
      accessibilityLabel={`${t(link.label)}: ${link.value}`}
      onPress={() => open(link.url)}
      style={{ minHeight: 44, padding: 8, flexDirection: 'row', alignItems: 'flex-start', width: '100%' }}>
      <FontAwesomeIcon icon={icons[link.kind]} color={theme.text.primary.toString()} size={20} style={{ flexShrink: 0 }} />
      <Label numberOfLines={0} variant={LabelType.titleDarkSmall}
        style={{ marginLeft: 6, flex: 1, minWidth: 0, lineHeight: 20, textAlign: 'left', textDecorationLine: 'underline' }}>
        {t(link.label)}: {link.value}
      </Label>
    </Pressable>)}
  </View>;
};

export default AtHomeContactActions;
